import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const VALID_BREAKPOINTS = [0.65, 1] as const;
const DEFAULT_BREAKPOINT = 0.65;

function snapBreakpoint(bp: unknown): number {
  if (typeof bp !== 'number') return DEFAULT_BREAKPOINT;
  let nearest: number = VALID_BREAKPOINTS[0];
  let bestDelta = Math.abs(bp - nearest);
  for (const candidate of VALID_BREAKPOINTS) {
    const delta = Math.abs(bp - candidate);
    if (delta < bestDelta) {
      bestDelta = delta;
      nearest = candidate;
    }
  }
  return nearest;
}

interface HomeViewState {
  mapOpen: boolean;
  mapBreakpoint: number;
  setMapOpen: (open: boolean) => void;
  setMapBreakpoint: (breakpoint: number) => void;
}

export const useHomeViewStore = create<HomeViewState>()(
  persist(
    (set) => ({
      mapOpen: true,
      mapBreakpoint: DEFAULT_BREAKPOINT,
      setMapOpen: (mapOpen) => set({ mapOpen }),
      setMapBreakpoint: (mapBreakpoint) => set({ mapBreakpoint }),
    }),
    {
      name: 'hp-home-view',
      storage: createJSONStorage(() => localStorage),
      version: 4,
      migrate: (persisted, version) => {
        if (version < 2 && persisted && typeof persisted === 'object') {
          return { mapOpen: true, mapBreakpoint: DEFAULT_BREAKPOINT };
        }
        if (version < 4 && persisted && typeof persisted === 'object') {
          const old = persisted as { mapOpen?: boolean; mapBreakpoint?: number };
          return {
            mapOpen: old.mapOpen ?? true,
            mapBreakpoint: snapBreakpoint(old.mapBreakpoint),
          };
        }
        return persisted as HomeViewState;
      },
      partialize: (state) => ({ mapOpen: state.mapOpen, mapBreakpoint: state.mapBreakpoint }),
    },
  ),
);
